module.exports = __webpack_public_path__ + "media/images/shared/popup_about/step-2-6b2edaf406ebe4d7b4a4c2c5d5eeae2d.jpg";